import React, { useContext, useState, useMemo, Fragment, useEffect } from 'react';
import { styleContextApp } from '../StyleContext';
import { ExploreWrapper, ExploreMainTitle, ExploreTitleWrapper, ExploreSubTitle,
    ExploreLine, ExploreSubLine, ExploreFilterNumber,
    FilterSettingBoardWrapper, KeywordChoiceWrapper, CrossWrapper, FilterIconWrapper,
    KeywordsWrapper, Keywords, Clear, TypeFilterWrapper, ArrowWrapper,BoardWrapper,
    BoardItemWrapper, HotelCardWrapper,HotelImg,HotelInfoWrapper,HotelTitle
    ,HotelDetail,HotelTagsWrapper,HotelTag ,HotelGoTo, ShowMoreWrapper, KeyWordLineWrapper, KeyWordKey, KeywordSelectItem, KeySelectItemWrapper, KeywordButtonWrapper, KeywordButton, EmptyModal, TagLineWrapper, TagSelectItemWrapper, TagButtonWrapper
} from './ExploreStyle';
import { Header } from '../../Component/Header/Header';
import { Footer } from '../../Component/Footer/Footer';
import correct from './Correct.png';
import double from './Double.png';
import more from './More.png';
import { ARROW_STYLE, POINT_STYLE, Swiper } from '../../Component/Swiper/Swiper';
import { imageDomain, STYLE_TYPE } from '../../Utils/magicStrings';
import { fetchData } from '../../Utils/fetch';
import { Modal } from '@mui/material';
import { Link, useParams } from 'react-router-dom';

export function Explore(props) {
    const { id } = useParams();
    const styleType = useContext(styleContextApp);
    const [ filteredHotel, setFilteredHotel ] = useState([]);
    const [ filter, setFilter ] = useState([]);
    const [ tagFilter, setTagFilter ] = useState(id ? [parseInt(id)] : []);
    const [ headerInfo, setHeaderInfo] = useState({picture: [], title: ''});
    const [ openModal, setOpenModal ] = useState(false);
    const [ condition, setCondition ] = useState([]);
    const [ tagCondition, setTagCondition ] = useState([]);

    useEffect(() => {
        window.scrollTo(0,0);
    },[]);


    const header = useMemo(() => (
        <Header styleType={styleType} pictures={headerInfo.picture} hasMarginTop={false} title={headerInfo.title}/>
    ), [headerInfo, styleType]);

    const line = useMemo(() => (
        <Fragment>
            <ExploreLine styleType={styleType}/>
            <ExploreSubLine styleType={styleType}/>
        </Fragment>
    ), [styleType]);

    const footer = useMemo(() => (
        <Footer styleType={styleType}/>
    ), [styleType]);

    useEffect(() => {
        const fresh = async() => {
            const inns = await fetchData(`inn?pageNumber=0&pageSize=10000${filter.map(e => `&optionIds=${e}`).join('')}${tagFilter.map(e => `&tagIds=${e}`).join('')}`);
            setFilteredHotel(inns?.content);
            if(inns?.content.length === 0 && filter.length !== 0)  setOpenModal(true);
        }
        fresh();
    }, [filter, tagFilter])

    useEffect(() => {
        const getInns = async () => {
            const condition = await fetchData('inn/condition');
            const headerPic = await fetchData('top');
            const inns = await fetchData(`inn?pageNumber=0&pageSize=10000${id ? `&tagIds=${id}` : ''}`);
            setFilteredHotel(inns?.content);
            setHeaderInfo({
                picture: headerPic?.primaryList.filter(e => e.imgUrl).map(e => `${imageDomain}/${e.imgUrl}`),
                title: headerPic?.primaryList.filter(e => e.title)[0].title
            });
            if(condition?.optionGroupList) {
                setCondition(condition?.optionGroupList);
                setTagCondition(condition?.tagList);
            }
        };

        getInns();
    }, []);

    return (
        <ExploreWrapper>
            {header}
            <div style={{width: 'min(1440px, 100vw)', margin: 'auto'}}>
            <ExploreTitle styleType={styleType} hotelNumber={filteredHotel.length}/>
            {line}
            
            <FilterSettingBoard 
                styleType={styleType} 
                setFilteredHotel={setFilteredHotel} 
                setFilter={setFilter}
                condition={condition}
                tagCondition={tagCondition}
                setTagFilter={setTagFilter}
                tagInitId={id ? [parseInt(id)] : []}
            />
            <HotelCards styleType={styleType} hotels={filteredHotel}/>
            {
                filteredHotel.length === 0 &&  filter.length !== 0 && 
                <Modal open={openModal}>
                    <EmptyModal styleType={styleType} >
                        <div className='title'>沒有找到符合您條件的旅舍</div>
                        <div className='content'>您可以更改關鍵詞重新搜索，或者查看我們為您推薦的旅舍。</div>
                        <div className='button' onClick={
                            () => {setOpenModal(false)}
                        }>返回檢索頁</div>
                    </EmptyModal>
                </Modal>
            }
            </div>
            {footer}
        </ExploreWrapper>
    );
};

const ExploreTitle = ({styleType, hotelNumber}) => {
    return(
        <ExploreTitleWrapper styleType={styleType}>
            <ExploreMainTitle styleType={styleType}>
                explore
            </ExploreMainTitle>
            <ExploreSubTitle styleType={styleType}>
                探索旅舍
            </ExploreSubTitle>
            <ExploreFilterNumber styleType={styleType}>
                <span id='text'>旅舍数</span>
                <span id='number'>{hotelNumber}</span>
            </ExploreFilterNumber>
        </ExploreTitleWrapper>
    )
};

 
// const tag = [{id: 0, name: '無視'},{id: 1, name: '道與理'},{id: 2, name: '是與'},{id: 3, name:'非非'},{id: 4, name:'繼續往天飛'},{id: 5, name:'再去遁地'},{id: 6, name:'在煩亂之中'},{id: 7, name:'找找氧氣'},{id: 8, name:'失意能否不'},{id: 9, name:'提起'},{id: 10, name: '無視'},{id: 11, name: '道與理'},{id: 12, name: '是與'}];

const FilterSettingBoard = ({styleType, condition = [], tagCondition=[], setFilter, setTagFilter, tagInitId}) => {
    const [ showBoard, setShowBoard ] = useState(false);
    const [ showType, setShowType ] = useState('keyword');
    const [ keywordFilter, setKeywordFilter ] = useState(tagInitId);
    const [ typeFilter, setTypeFilter ] = useState([]); 
    useEffect(() => {
        setTypeFilter(new Array(condition.length).fill(-1));
    }, [condition.length]);
    const typeWrapper = useMemo(() => {
        const Item = (mapIndex, e) => {
            return (<KeywordSelectItem styleType={styleType} key={`type_${mapIndex}_${e.id}`} onClick={() => {
                setTypeFilter(oldKey => {
                    return oldKey.map((ele, i) => {
                        if(i === mapIndex) {
                            if( ele === e.id) {
                                return -1;
                            } else {
                                return e.id;
                            }
                        }
                        else return ele;
                    })
                });
            }} isChosen={typeFilter.includes(e.id)}>
                {e.name}
            </KeywordSelectItem>)
        };

        const conditionLine =  condition.map((element, mapIndex) => {
            const keyLine = new Array(Math.ceil(element.optionList.length / 6)).fill(0);
            return (
                <KeyWordLineWrapper key={`${element.name}_${mapIndex}`} styleType={styleType}>
                    <KeyWordKey styleType={styleType}>{element.name}</KeyWordKey>
                    {
                        styleType !== STYLE_TYPE.MOBILE && 
                        <KeySelectItemWrapper styleType={styleType} >
                    {
                    element.optionList.map(e => {
                        return Item(mapIndex, e);
                    })}
                    </KeySelectItemWrapper>}

                    {
                        styleType === STYLE_TYPE.MOBILE && (
                            keyLine.map((line, index) => {
                               return <KeySelectItemWrapper key={`option_${index}`} styleType={styleType}>
                                    {element.optionList.slice(index * 6, (index + 1) * 6 ).map(e => {
                                        return Item(mapIndex, e);
                                    })}
                                </KeySelectItemWrapper>
                            })
                        )
                    }
                    
                </KeyWordLineWrapper>
            );
        });

        return (
            <>
                {conditionLine}
                <KeywordButtonWrapper styleType={styleType}>
                    <KeywordButton styleType={styleType} isSave={true} onClick={() => {
                        setFilter(typeFilter.filter(e => e !== -1));
                        setShowBoard(false);
                    }}>保存</KeywordButton>
                    <KeywordButton styleType={styleType} isSave={false} onClick={() => {
                        setFilter([]);
                        setTypeFilter(new Array(condition.length).fill(-1));
                        setShowBoard(false);
                    }}>清除</KeywordButton>
                </KeywordButtonWrapper>
            </>
        )
    }, [condition, styleType, typeFilter, setFilter]);

    const keywordWrapper = useMemo(() => {
        const Item = (mapIndex, e) => {
            return (<KeywordSelectItem styleType={styleType} key={`item_${e.id}`} onClick={() => {
                setKeywordFilter(oldKey => {
                    if(oldKey.includes(e.id)) {
                        const newA = Array.from(new Set(oldKey));
                        newA.splice(oldKey.findIndex(el=> el === e.id), 1);
                        return newA;
                    }
                    return Array.from(oldKey).concat(e.id);
                });
            }} isChosen={keywordFilter.find(k => String(k) === String(e.id))}>
                {e.name}
            </KeywordSelectItem>)
        };
            const inOneLine = styleType === STYLE_TYPE.MOBILE ? 4 : 10;
            const keyLine = new Array(Math.ceil(tagCondition.length / inOneLine)).fill(0);
            const line =  (
                <TagLineWrapper styleType={styleType}>
                            {keyLine.map((_, index) => {
                               return (<div key={`wrapper_${index}`}><TagSelectItemWrapper  styleType={styleType}>
                                    {tagCondition.slice(index * inOneLine, (index + 1) * inOneLine ).map((e, tagI) => {
                                        return Item(tagI, e);
                                    })}
                                </TagSelectItemWrapper></div>)
                            })}
                    
                </TagLineWrapper>
            );

            return (
                <>
                    {line}
                    <TagButtonWrapper styleType={styleType}>
                        <KeywordButton styleType={styleType} isSave={true} onClick={() => {
                            setTagFilter(Array.from(new Set(keywordFilter)));
                            setShowBoard(false);
                        }}>保存</KeywordButton>
                        <KeywordButton styleType={styleType} isSave={false} onClick={() => {
                            setTagFilter([]);
                            setKeywordFilter([]);
                            setShowBoard(false);
                        }}>清除</KeywordButton>
                    </TagButtonWrapper>
                </>

            )
    }, [keywordFilter, setTagFilter, styleType, tagCondition]);

    return(
        <Fragment>
            <FilterSettingBoardWrapper styleType={styleType}>
                <KeywordChoiceWrapper styleType={styleType} onClick={() => {
                    setShowType(e => {
                        if(e === 'type') {
                            return 'keyword';
                        }
                        return e;
                    });
                    setShowBoard(e => {
                        if(e && showType === 'keyword') return false;
                        else return true;
                    });
                }}>
                    {showType === 'keyword' && showBoard && (
                        <CrossWrapper 
                            styleType={styleType} 
                            PCSize={17} 
                            MobileSize={12} 
                            color={'black'} 
                            showMargin={true}
                        >
                            <div id='left'/><div id='right'/>
                        </CrossWrapper>
                    )}
                    {((!showBoard) || showType === 'type') && (
                        <FilterIconWrapper styleType={styleType}>
                            <div id='upperLine'/><div id='upperPoint'/>
                            <div id='lowerLine'/><div id='lowerPoint'/>
                        </FilterIconWrapper>
                    )}
                    <span>選擇關鍵詞</span>
                </KeywordChoiceWrapper>
                {!showBoard && keywordFilter.filter(e => e).length !== 0 && ( 
                <>
                <KeywordsWrapper styleType={styleType} onClick={() => setShowBoard(e => !e)} >
                    查看已選關鍵詞
                </KeywordsWrapper>           
                <Clear  
                    styleType={styleType}
                    onClick={() => {
                        setKeywordFilter([]);
                        setTagFilter([]);
                    }}
                >
                    {'全部清除'}
                </Clear></>)}

                <TypeFilterWrapper styleType={styleType}
                    onClick={() => {
                        setShowType(e => {
                            if(e === 'keyword') {
                                return 'type';
                            }
                            return e;
                        });
                        setShowBoard(e => {
                            if(e && showType === 'type') return false;
                            else return true;
                        });
                    }}
                >
                    <ArrowWrapper styleType={styleType} arrow={showType==='type' && showBoard ? 'up' : 'down'} PCSize={7} mobileSize={5}/>
                    <span id='text'>個性化篩選</span>
                    {/* {typeFilter.length > 0  && <span id='has'>（已选择）</span>} */}
                </TypeFilterWrapper>
            </FilterSettingBoardWrapper>

            { showBoard && 
                    <BoardWrapper styleType={styleType} type={showType}>
                        { showType === 'keyword' &&  keywordWrapper}
                        { showType === 'type' &&  typeWrapper }

                    </BoardWrapper>
                }

        </Fragment>
    );
};




const HotelCards = ({styleType, hotels}) => {
    const [showNumber, setShowNumber] = useState(6);

    return (
        <Fragment>
            {hotels.slice(0, showNumber).map(hotel => {
                return <HotelCard hotelInfo={hotel} key={hotel.innId} styleType={styleType} />
            })}
            {showNumber < hotels.length && 
                <ShowMoreWrapper 
                    styleType={styleType}
                    onClick={() => {
                        setShowNumber(e => e+6);
                    }}
                >
                    <span>查看更多</span>
                    <img src={more} alt=''></img>
                </ShowMoreWrapper>}
        </Fragment>
    )

};

const HotelCard = ({styleType, hotelInfo}) => {
    const pictureElements = hotelInfo.imgUrlList.map((e, index) => (
        <div className='wrapper' 
            key={index} 
            style={{display: 'inline-block', position: 'relative', width: '100%', height: '100%', overflow: 'hidden'}} >
                <img data-src={`${imageDomain}/${e}`} className='lazyload' alt='' style={{position: 'absolute', left: '50%', top: '50%',  transform: 'translate(-50%, -50%)'}}  />
        </div>)
    );
    return (
        <HotelCardWrapper styleType={styleType}>
            <HotelImg styleType={styleType}>
                <Swiper 
                    height={styleType === STYLE_TYPE.MOBILE ? 217 : 343} 
                    isAutoPlay={false} 
                    pointStyle={POINT_STYLE.NONE} 
                    arrowStyle={ARROW_STYLE.WHITE_CIRCLE_2}  
                    elements={pictureElements} 
                    isLoop={true} 
                    hasArrow={true}
                />
            </HotelImg>
            <HotelInfoWrapper styleType={styleType}>
                <HotelTitle styleType={styleType}>{`${hotelInfo.name}-${hotelInfo.title}`}</HotelTitle>
                <HotelDetail styleType={styleType}>{hotelInfo.overview}</HotelDetail>
                <HotelTagsWrapper styleType={styleType}>
                    {hotelInfo.tagList?.map(e => (<HotelTag styleType={styleType} key={e.id}>#{e.name}</HotelTag>))}
                </HotelTagsWrapper>
                <Link to={`/detail/${hotelInfo.innId}`}>
                    <HotelGoTo styleType={styleType}>
                        <span id='text'>旅舍詳情</span>
                        <img src={double} alt=''></img>
                    </HotelGoTo>
                </Link>
            </HotelInfoWrapper>
        </HotelCardWrapper>
    )
};

// const KeywordItem = ({setKeywordFilter, setTypeFilter,  styleType, keyword}) => {
//     return(
//         <Keywords styleType={styleType} >
//             <span>{keyword}</span>
//             <CrossWrapper 
//                 styleType={styleType} 
//                 PCSize={9} 
//                 MobileSize={17} 
//                 color={'white'} 
//                 showMargin={false}
//                 onClick={() => {
//                     setKeywordFilter(e => {
//                         const newfilter = e.filter(ele => keyword!==ele);
//                         return newfilter;
//                     });
//                     setTypeFilter(e => {
//                         const newfilter = e.filter(ele => keyword!==ele);
//                         return newfilter;
//                     })
//                 }}
//             >
//                 <div id='left'/><div id='right'/>
//             </CrossWrapper>
//     </Keywords>
//     );
// }

// const BoardItem = ({styleType, type, item, haschecked, onClick}) => {
//     return (
//         <BoardItemWrapper 
//             styleType={styleType}
//             type={type}
//             haschecked={haschecked}
//             onClick={onClick}
//         >
//             { type === 'keyword' && <span id='sharp'>#</span>}
//             { type === 'type' && <span id='checkedPC' ><img src={correct} alt=''/></span>}
//             <span id='text'>{ item }</span>
//             { type === 'type' && <span id='checkedMobile'><img src={correct} alt=''/></span>}
//         </BoardItemWrapper>
//     )
// };